<header class="page_header">
  <div class="header_content">
    <div class="text_and_supporting_text">
      <div class="page_title">Shipping Bill</div>
    </div>
    <button class="btn tertiary_button" (click)="openRightPanelForLeoUpdate()">
      <app-svg-icon [path]="'assets/icons/plus_icon.svg'" style="background: #0E4E96"></app-svg-icon>
      Update Leo
    </button>
    <button class="btn primary_button" (click)="addNewShippingBill()">
      <app-svg-icon [path]="'assets/icons/plus_icon.svg'"></app-svg-icon>
      Add New
    </button>


  </div>
</header>
<div class="search_bar_with_table">
  <div class="content">
    <app-tos-table
      [showTableStats]="false"
      [filterConfig]="ShippingBillListingPageConfig.filterConfig"
      [searchBarConfig]="ShippingBillListingPageConfig.searchBarConfig"
      [tableMeta]="tableMeta"
      [tableMenuOptions]="menuOptions"
      [(dataListRequest)]="tableListRequest"
      [dataListResponse]="tableListData"
      [(selectedItems)]="selectedItems"
      [defaultFilters]="ShippingBillListingPageConfig.defaultFilters"
      (tosTableAction)="getTableList()"
      (tableMenuOptionSelected)="handleOptionSelected($event)"
    >
    </app-tos-table>
  </div>
</div>


<ng-template #leoUpdateTemplate>
  <div class="leo_update_template">
    <div class="top_action_bar">
      <div class="search-container">
        <app-autocomplete-dropdown
          id="search-bar"
          class="autocomplete-dropdown"
          [placeholder]="'Search And Add Shipping Bills'"
          [apiUrl]="'v1/shipping-bill-items/list'"
          [filterByKeys]="['DOCUMENT_NO_CONTAINS']"
          [limit]="10"
          [bindLabel]="'documentNo'"
          [bindValue]="'id'"
          [displayColumns]="[
    {key: 'documentNo', header: 'Document Number'}
    ]"
          [additionalFilters]="[
                {
                  'name': 'DOCUMENT_TYPE_EQUALS',
                  'alias': 'DOCUMENT_TYPE_EQUALS',
                  'value': ['SHIPPING_BILL']
                },
                {
                  'name': 'DOCUMENT_NO_NOT_IN',
                  'alias': 'DOCUMENT_NO_NOT_IN',
                  'value': getAddedShippingBillsDocumentNo()
                }
              ]"
          (suggestionSelected)="selectShippingBillForLeoUpdate($event)"
          [(ngModel)]="searchAndAddText"
        >
        </app-autocomplete-dropdown>
        <button type="button"
                class="add-button tertiary_button" (click)="addShippingBillForLeoUpdate()"
                [disabled]="!selectedLeoUpdateShippingBill"
        >
          <app-svg-icon class="image-icon" [path]="'assets/icons/add_plus_icon.svg'"></app-svg-icon>
          <span>Add</span>
        </button>
      </div>
      @if (selectedItems.length > 0) {
        <div class="action_btns">
          <button class="secondary_button" (click)="handleBulkDelete()">Delete</button>
        </div>
      }
    </div>
    <app-editable-table
      [tableHeaders]="editableTableMetaForLeoUpdate"
      [(tableData)]="shippingBillsForLeoUpdate"
      [deletionAllowed]="true"
      (dataDeleted)="handleBulkDelete($event)"
    >
    </app-editable-table>
  </div>
</ng-template>
